import { ClientResponseAuditable } from 'src/app/web-api-client';

export class Client {
  id: number;
  name: string;
  isActive?: boolean;

  constructor(clientResponse: ClientResponseAuditable) {
    if (!clientResponse.clientId || !clientResponse.name)
      console.error('"clientId" and "name" properties are required.');
    this.id = clientResponse.clientId!;
    this.name = clientResponse.name!;
    this.isActive = clientResponse.isActive!;
  }
}
